<template>
  <footer class="footer">
    <div class="container">
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <a href="https://buypower.ng" target="_blank">Buypower Inc</a> |
        <a href="https://buypower.ng/privacy-policy" target="_blank">Privacy Policy</a> |
        <a href="https://buypower.ng/terms-of-use" target="_blank">Terms of Use</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
.footer {
  padding: 15px 0;
  background-color: #f5f5f5;
  color: #666;
  font-size: 14px;
}
.footer a {
  color: inherit;
  text-decoration: none;
  margin: 0 5px;
}
.footer a:hover {
  text-decoration: underline;
}
</style>
